import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from './header/header.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../app.module';
import { HttpClient } from '@angular/common/http';
import { OverlaySpinnerComponent } from './overlay-spinner/overlay-spinner.component';
import { ScrollCardModule } from '../directives/scroll-card/scroll-card.module';
import { ListCardsComponent } from './list-cards/list-cards.component';
import { ListEventsComponent } from './list-events/list-events.component';
import { GenericCardComponent } from './generic-card/generic-card.component';
import { PDFViewerComponentModule } from './pdf-viewer/pdf-viewer.module';
import { GoogleMapsPlacesComponent } from './google-maps-places/google-maps-places.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { RegistersAfterBeforeComponent } from './registers-after-before/registers-after-before.component';
import { RouteCardComponent } from './route-card/route-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LazyImageComponent } from './lazy-image/lazy-image.component';
import { KeyboardOnScreenComponent } from './keyboard-on-screen/keyboard-on-screen.page';
import { ListRoutesComponent } from './list-routes/list-routes.component';
import { CallToActionComponent } from './calltoaction/calltoaction.component';
import { HeaderHomeNewComponent } from '../pages/home/components/header-home-new/header-home-new.component';
import { SwiperModule } from 'swiper/angular';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { UiScrollModule } from 'ngx-ui-scroll';
import { CategoriesListPage } from '../pages/categories-list/categories-list.page';
import { CategoriesFilterComponent } from '../pages/categories-list/components/categories-filter/categories-filter.component';
import { FiltersCalendarComponent } from '../pages/categories-list/components/categories-filter/components/filters-calendar/filters-calendar.component';
import { CalendarModule } from 'ion2-calendar';
import { MancomunityCategoriesFilterComponent } from '../pages/mancomunity-categories-list/components/categories-filter/mancomunity-categories-filter.component';
import { MancomunityCategoriesListPage } from '../pages/mancomunity-categories-list/mancomunity-categories-list.page';
import { MancomunityFiltersCalendarComponent } from '../pages/mancomunity-categories-list/components/categories-filter/components/filters-calendar/mancomunity-filters-calendar.component';

@NgModule({
 declarations: [
    HeaderComponent,
    OverlaySpinnerComponent,
    ListCardsComponent,
    GenericCardComponent,
    KeyboardOnScreenComponent,
    ListEventsComponent,
    LazyImageComponent,
    HeaderHomeNewComponent,
    RegistersAfterBeforeComponent,
    PrivacyComponent,
    GoogleMapsPlacesComponent,
    RouteCardComponent,
    ListRoutesComponent,
    CallToActionComponent,
    MancomunityCategoriesListPage,
    MancomunityCategoriesFilterComponent,
    MancomunityFiltersCalendarComponent,
    CategoriesListPage,
    CategoriesFilterComponent,
    FiltersCalendarComponent
 ],
 imports: [
   CommonModule,
   IonicModule,
   ScrollCardModule,
   SwiperModule,
   LazyLoadImageModule,
   ScrollingModule,
   UiScrollModule,
   PDFViewerComponentModule,
   ReactiveFormsModule,
   CalendarModule,
   FormsModule,
   TranslateModule.forChild({
      loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
      }
    })
 ],
 exports: [
    HeaderComponent,
    OverlaySpinnerComponent,
    ListCardsComponent,
    KeyboardOnScreenComponent,
    GenericCardComponent,
    ListEventsComponent,
    HeaderHomeNewComponent,
    RegistersAfterBeforeComponent,
    PrivacyComponent,
    LazyImageComponent,
    GoogleMapsPlacesComponent,
    RouteCardComponent,
    ListRoutesComponent,
    CallToActionComponent,
    MancomunityCategoriesListPage,
    MancomunityCategoriesFilterComponent,
    CategoriesListPage,
    CategoriesFilterComponent,
    FiltersCalendarComponent,
    MancomunityFiltersCalendarComponent,
 ]
})
export class SharedModule { }